<template>
  <v-radio-group v-model="radioGroup" :rules="rules" :label="label" :disabled="disabled" row dense>
    <div v-for="(item,index) in items" :key="index">
      <v-radio :color="color " :label="item.label" :value="item.value"></v-radio>
    </div>
  </v-radio-group>
</template>

<script>
  export default {
    name: "RyouRadio",
    props: {
      value: {
        type: String,
        required: false,
        default: ""
      },
      rules: {
        type: Array,
        required: false,
        default: () => []
      },
      color: {
        type: String,
        required: false,
        default: "primary"
      },
      items: {
        type: Array,
        required: true,
        default: () => []
      },
      label: {
        type: String,
        required: false
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    data() {
      return {};
    },
    computed: {
      radioGroup: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit("input", val);
        }
      }
    }
  };
</script>
<style>
  .v-input--radio-group.v-input--radio-group--row .v-radio {
    margin-right: 10px !important;
  }
</style>